import './App.css';
import Navbar from './components/Navbar';
import { Route, Routes } from 'react-router-dom';
import Footer from './components/Footer';
import Calculator from './components/Calculator';
import MainHero from './components/MainHero';

function App() {
  return (

    <>
      <Navbar></Navbar>
      <Routes>
        <Route path="/" element={<MainHero />} />
        <Route path="/Calculator" element={<Calculator/>}/>
      </Routes>
      <Footer></Footer>
    </>
  );
}

export default App;
